import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'
import { ICart, IDelivery } from '../../cart/ICart'

export const splitDeliveries = (cartData?: ICart) => {
    const deliveries = cartData?.cart_contents?.deliveries ?? []
    const physicalDeliveries: IDelivery[] = []
    const virtualDeliveries: IDelivery[] = []

    deliveries.forEach((delivery) => {
        const isPhysical = delivery?.resolved_data?.delivery_options?.some(
            (option: any) =>
                option?.medium?.medium_type === MEDIUM_TYPE_PHYSICAL
        )

        if (isPhysical) {
            physicalDeliveries.push(delivery)
        } else {
            virtualDeliveries.push(delivery)
        }
    })

    return { physicalDeliveries, virtualDeliveries }
}

export const eligibleForMultipleShipments = (cart?: ICart) => {
    const featureFlag = process.env.NEXT_PUBLIC_MULTI_SHIP == '1'

    if (!cart || !featureFlag) return false

    const { physicalDeliveries } = splitDeliveries(cart) ?? []

    if (physicalDeliveries.length > 1) {
        // cart already has multiple deliveries
        return true
    }

    if (physicalDeliveries.length === 1) {
        const boxIds: any = {}

        const uniqueItems = physicalDeliveries[0].line_items.filter(
            (item: any) => {
                const id = item?.customization_data?.box_uuid

                if (!id) {
                    // physical item that is not part of a box
                    return true
                }

                if (!boxIds[id]) {
                    // box item in a box that has not been encountered yet
                    boxIds[id] = true
                    return true
                } else {
                    // box item in a box already encountered
                    return false
                }
            }
        )

        return uniqueItems.length > 1
    }

    return false
}

export const getOptionsFromDelivery = (
    delivery: IDelivery,
    isMultipleShipments: boolean
) => {
    const baseOptions = delivery?.resolved_data?.delivery_options ?? []

    return baseOptions.filter((option: any) => {
        const isUsps = option?.carrier?.carrier_name.toLowerCase() === 'usps'

        const plasticsCount = delivery.line_items.filter(
            (lineItem) =>
                lineItem.product?.resolved_data?.product_medium?.medium_type ===
                MEDIUM_TYPE_PHYSICAL
        ).length

        return !(isUsps && plasticsCount > 1 && !isMultipleShipments)
    })
}

export const getCarrierFromOption = ({
    options = [],
    uuid,
}: {
    options: any[]
    uuid: string
}) => {
    const deliveryOption = options.find(
        (option) => option.delivery_option_uuid === uuid
    )

    return deliveryOption?.carrier?.carrier_name ?? ''
}
